export const Nav = () => {
    return {
        selected: false,

        init () {
        },

        open(index = true, toggle = true) {

            if(!toggle) {
                this.selected = index;
            } else {
                this.selected = this.isOpen( index ) ? false : index;
            }

        },

        isOpen(index = true) {
            return this.selected === index;
        }
    }
}
